export default __webpack_public_path__ + "static/media/link.0dd4c01e.svg";